import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _sortQueryMapper;

import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { ChallengeSortType } from './challenge-sort';
export var SortAndFilter = t.partial({
  challengeSortBy: ChallengeSortType,
  challengeFilters: t.type({
    showInProgressOnly: t["boolean"],
    selectedCategories: t.array(t.string)
  })
});
export var sortQueryMapper = (_sortQueryMapper = {}, _defineProperty(_sortQueryMapper, ChallengeSortType.map.Recommended, 'RECOMMENDED'), _defineProperty(_sortQueryMapper, ChallengeSortType.map.Newest, 'NEWEST'), _defineProperty(_sortQueryMapper, ChallengeSortType.map.MostPoints, 'MOST_POINTS'), _sortQueryMapper);
export var ChallengeCategoriesItem = t.type({
  id: t.string,
  name: t.string
});
var SocialAccount = t.type({
  __typename: t.keyof({
    Facebook: null,
    Linkedin: null,
    Twitter: null,
    Apple: null,
    OAuth2: null,
    Google: null
  }),
  id: t.string,
  connected: t["boolean"]
});
var Profile = t.type({
  id: t.string,
  avatarUrl: nullable(t.string),
  company: nullable(t.string),
  title: nullable(t.string),
  socialAccounts: t.array(SocialAccount)
});
var Topic = t.type({
  edges: nullable(t.array(t.type({
    node: t.type({
      slug: t.string
    })
  })))
});
export var GetAvailableEntitiesOutput = t.type({
  rewards: nullable(t.type({
    edges: nullable(t.array(t.type({
      node: t.type({
        id: t.string
      })
    })))
  })) // TODO(maddy.leadbetter): Add back when Discussions are supported
  // topics: nullable(Topic)

});
export var ChallengeStates = {
  AVAILABLE: 'AVAILABLE',
  LATER: 'LATER',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  COMPLETED: 'COMPLETED'
};
export var ChallengeState = S.enums(ChallengeStates);
export var ChallengeListBlockConfig = S.struct({
  typename: S.literal('ChallengeListBlock'),
  id: S.string,
  hash: S.string,
  state: S.optional(ChallengeState),
  categoryId: S.optional(S.number),
  channelId: S.optional(S.string)
});